import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/reset.scss'
import './assets/css/main.scss'
import AOS from 'aos'
createApp(App).AOS = new AOS.init({ 
  disable: false,
  startEvent: 'DOMContentLoaded',
  initClassName: 'aos-init',
  animatedClassName: 'aos-animate',
  offset: 300,
  duration: 750,
  easing: 'ease-out',
  once: true
})
import 'aos/dist/aos.css'
import './libs/rem'
createApp(App).use(store).use(router).mount('#app')
